import React from 'react'
import { Icon, Text } from 'components/dataDisplay'

import messages from './messages'


type SecurePaymentDisclaimerProps = {
  className?: string
  iconColor?: 'gold-30' | 'green'
}

const SecurePaymentDisclaimer: React.FunctionComponent<SecurePaymentDisclaimerProps> = (props) => {
  const { className, iconColor = 'gold-30' } = props

  return (
    <div className={className}>
      <div className="flex items-center justify-start">
        <Icon className="mr-8" name="24/lock" color={iconColor} />
        <Text style="t2" message={messages.title} />
      </div>
      <Text className="mt-4" style="p2" message={messages.text} />
    </div>
  )
}


export default SecurePaymentDisclaimer
